<template>
    <el-dialog
        :title="isForm ? (typeId ? '编辑' + dialogTitle : '添加房间类型') : '查看'"
        :model-value="modelValue"
        width="600px"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            :rules="isForm ? formRules : {}"
            :validate-on-rule-change="false"
            label-width="120px"
            style="max-width: 560px"
        >
            <el-form-item label="类型名称" prop="name">
                <el-input v-if="isForm" v-model="formData.name" placeholder="请输入类型名称"></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="类型编码" prop="code">
                <el-input v-if="isForm" v-model="formData.code" placeholder="请输入类型编码"></el-input>
                <span v-else>{{ formData.code }}</span>
            </el-form-item>
            <el-form-item label="显示排序" prop="list_order">
                <el-input-number
                    v-if="isForm"
                    v-model="formData.list_order"
                    class="mx-4"
                    :min="0"
                    :max="999999"
                    controls-position="right"
                />
                <span v-else>{{ formData.list_order }}</span>
            </el-form-item>
            <!-- <el-form-item label="状态" prop="status">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">启用</el-radio>
                    <el-radio :value="0">禁用</el-radio>
                </el-radio-group>
                <span v-else>{{ formData.status == 0 ? '禁用' : '启用' }}</span>
            </el-form-item> -->
            <el-form-item label="备注" prop="remark">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea" placeholder="请输入备注"></el-input>
                <div v-else>{{ formData.remark || '-' }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addRoomTypeApi, getRoomTypeDetail, putRoomTypeApi } from '@/api/roomType.js'
import { ElMessage } from 'element-plus'
import { getItem } from '@/utils/storage'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    typeId: {
        type: String,
        required: false
    }
})

const emits = defineEmits(['update:modelValue', 'updateForm'])
// 表单源
const formData = ref({
    name: '',
    code: '',
    list_order: 0,
    status: 1,
    visible: 1,
    remark: ''
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入类型名称'
        }
    ],
    code: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入类型编码'
        }
    ]
})
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}
// 提交data数据修饰
const getPostFormData = () => {
    const postFormData = {}
    if (formData.value.id) {
        postFormData.id = formData.value.id
    }
    postFormData.name = formData.value.name
    postFormData.code = formData.value.code
    postFormData.list_order = formData.value.list_order
    postFormData.status = formData.value.status
    postFormData.module = formData.value.module
    postFormData.remark = formData.value.remark
    if (props.schoolId && !getItem('userInfo')?.school) {
        postFormData.school = props.schoolId
    }

    return postFormData
}
// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    const postData = getPostFormData()
    if (props.typeId !== '') {
        await doPutRoomType(postData)
    } else {
        await doAddRoomType(postData)
    }
}

// 修改
const doPutRoomType = async (postData) => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await putRoomTypeApi({ ...postData, school: formData.value.school })
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// 添加
const doAddRoomType = async (postData) => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await addRoomTypeApi({ ...postData, school: formData.value.school })
            // 模块添加成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}
const dialogTitle = ref('')
// 获取品牌详情
const doGetSubjectModelDetail = async () => {
    const { id, name, code, list_order, status, module, remark } = await getRoomTypeDetail(props.typeId)
    dialogTitle.value = name
    formData.value = {
        id,
        name,
        code,
        list_order,
        module,
        status,
        remark
    }
}

// 只有macId有的时候，才会去请求数据
watch(
    () => props.typeId,
    (newVal) => {
        // getOptionData()
        if (newVal) {
            doGetSubjectModelDetail()
        } else {
            // 置空
            formData.value = {
                id: '',
                mac: '',
                room: { id: '' },
                list_order: 1,
                status: 1,
                remark: ''
            }
        }
    }
)
</script>

<style lang="scss" scoped>
.albums-lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .img-item {
        width: 100px;
        height: 100px;
        background-color: #999;
        border-radius: 5px;
        margin-right: 10px;
    }
}

.albums-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;

        .avatar-uploader-icon {
            margin-top: 36px;
        }
    }

    :deep(.el-upload-list__item-preview),
    :deep(.el-icon--zoom-in) {
        display: none;
    }
}

.files-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100%;
        height: auto;
    }
}
</style>
